import React from 'react';
// import logo from './logo.svg';
import './App.css';
import { Home } from 'screens/home';
import { Affirm } from 'screens/affirm';
//@ts-ignore
import { Provider } from "react-redux";
import { store } from "core/redux/store";
import ApolloClient from 'apollo-boost';
import { ApolloProvider } from '@apollo/react-hooks';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { Router, Location, Redirect, navigate } from "@reach/router";
import { MoveWithForm } from 'screens/moveWithForm';
import List from 'screens/list/List';
import { ThankyouScreen } from 'screens/thankyouScreen';
import { Thankyou } from 'screens/thankyou';
import { AffirmThankyou } from 'screens/affirmThankyou';
import { AffirmCancellation } from 'screens/affirmCancellation';
import { Booked } from './components/Booked'
import { LandingBooked } from './components/LandingBooked'

import { getEstimatorDetailsNormal } from 'core/services/movewithService'
import { getEstimatorDetails } from 'core/services/getEstimatorDetailsService'
import { AmsLanding } from './components/amsLanding';
import { PayDeposit } from './components/payDeposit';
import { EstimateDetails } from 'screens/estimateDetails';
import { getCustomerDetails } from 'core/services/getCustomerDetailsService'
declare var window: any;
var graphqlEndpoint = ""
var depositurl = ""
var estimatorurl = ""
//http://localhost:3000/?customerid=7052856&customerToken=0b86a75d-e90d-4436-8554-49f805c55b9c
//http://interstatedev.allmysons.com/?customerid=7052856&customerToken=0b86a75d-e90d-4436-8554-49f805c55b9c
console.log(window.deployment);
if (window.deployment === "staging") {
  graphqlEndpoint = "https://amsfanclubapi.allmysonsstagingbeanstalk.com/graphql/"
  //graphqlEndpoint=" https://amsfanclubgraphqlprodapi-prod.us-east-1.elasticbeanstalk.com/graphql/"
  depositurl = "http://pricingapistaging.allmysons.com/Estimator/SavePaymentCreditCard"
  estimatorurl = "https://pricingapistaging.allmysons.com/Estimator/"
}
else if (window.deployment === "uat") {
  graphqlEndpoint = "https://amsfanclubapiuat.allmysonsbeanstalk.com/graphql"
  //graphqlEndpoint="https://amsfanclubapitest.allmysonsbeanstalk.com/graphql/"
  depositurl = "http://pricingapinew.allmysons.com/Estimator/SavePaymentCreditCard"
  estimatorurl = "https://pricingapinew.allmysons.com/Estimator/"
}
else {
  graphqlEndpoint = "https://amsfanclubapi.allmysonsbeanstalk.com/graphql"
  //graphqlEndpoint="https://amsfanclubapitest.allmysonsbeanstalk.com/graphql/"
  depositurl = "http://pricingapi.allmysons.com/Estimator/SavePaymentCreditCard"
  estimatorurl = "https://pricingapi.allmysons.com/Estimator/"
}

export const endpoints = {
  graphql: graphqlEndpoint,
  payment: depositurl,
  estimator: estimatorurl
}


console.log(endpoints);
export const client = new ApolloClient({
  //uri: 'https://amsfanclubapi.allmysonsbeanstalk.com/graphql',//Production
  //   uri: 'https://amsfanclubapi.allmysonsstagingbeanstalk.com/graphql/', //Staging
  uri: endpoints.graphql
});


const ProtectedRoute = ({ component: Component, ...rest }: any) => (
  // isLogin() ? <Component {...rest} /> : <Redirect from="" to={"/getcode"} noThrow />
  <Component {...rest} />
  // isLogin() ? <Component {...rest} /> : <Redirect from="" to={"/getcode"} noThrow />
  //isLogin() ? <Component {...rest} /> : <Redirect from="" to={"/sponsorLogin"} noThrow />
);

const PublicRoute = ({ component: Component, ...rest }: any) => (
  <Component {...rest} />
);

const FadeTransitionRouter = (props: any) => (
  <Location>
    {({ location }: any) => (
      <TransitionGroup className="transition-group">
        <CSSTransition key={location.key} classNames="fade" timeout={500}>
          {/* the only difference between a router animation and
              any other animation is that you have to pass the
              location to the router so the old screen renders
              the "old location" */}
          <Router location={location} className="router">
            {props.children}
          </Router>
        </CSSTransition>
      </TransitionGroup>
    )}
  </Location>
);

function Routes(props: any) {
  return (
    <Router {...props} >
      <PublicRoute path="/amsLanding" component={AmsLanding} />
      <PublicRoute path="/affirm" component={Affirm} />
      <PublicRoute path="/newThankyou" component={ThankyouScreen} />
      <PublicRoute path="/thankyou" component={Thankyou} />
      <PublicRoute path="/affirmThankyou" component={AffirmThankyou} />
      <PublicRoute path="/affirmCancellation" component={AffirmCancellation} />
      <PublicRoute path="/payDeposit" component={PayDeposit} />
      <PublicRoute path="/booked" component={Booked} />
      <PublicRoute path="/landingBooked" component={LandingBooked} />

      <PublicRoute path="/estDetail" component={EstimateDetails} />
      <List path="/" />
      <List path="/:index">
        {/* <PopupScreen path="/popup" /> */}
      </List>
      {/* <PopupScreen path="/popup" />
      <Thankyou path="/thanks" />
      <Login path="/login"></Login>
      <SignUp path="/signup"></SignUp>
      <Coupon path="/coupon" /> */}
    </Router>
  );
}

const App: React.FC = () => {
  // return (
  // <Provider store={store}>
  //   <ApolloProvider client={client}>
  //     {/* <CookiesProvider> */}
  //     <FadeTransitionRouter>
  //       <List path="/" />
  //       <List path="/:index"></List>
  //       <PublicRoute path="/moveWithForm" component={MoveWithForm} />

  //       <ProtectedRoute path="/amsLanding" component={AmsLanding} />
  //       <ProtectedRoute path="/affirm" component={Affirm} />
  //       {/* <ProtectedRoute path="/" component={Home}> */}
  //       {/* </ProtectedRoute> */}
  //     </FadeTransitionRouter>
  //     {/* </CookiesProvider> */}
  //   </ApolloProvider>
  // </Provider>
  // <div className="App">
  /* <header className="App-header">
    <img src={logo} className="App-logo" alt="logo" />
    <p>
      Edit <code>src/App.tsx</code> and save to reload.
    </p>
    <a
      className="App-link"
      href="https://reactjs.org"
      target="_blank"
      rel="noopener noreferrer"
    >
      Learn React
    </a>
  </header> */
  // <Home/>
  // </div>

  React.useEffect(() => {
    //localStorage.clear();
    //debugger;
    console.log("INNNNNNNNNNNNNNNNNNNNNNNNNNnn")
    const params = new URLSearchParams(window.location.search);
    const phone = params.get('phone') || "8442070741"; //
    var CID = params.get('customerid');
    var securetoken = params.get('customerToken');
    if (!CID) {
      CID = localStorage.getItem("CID")
    }
    else {
      localStorage.setItem("CID", CID)
    }
    if (!securetoken) {
      securetoken = localStorage.getItem("securetoken")
    }
    else {
      localStorage.setItem("securetoken", securetoken)
    }
    //  localStorage.setItem("CID",CID||"6981124");
    //localStorage.setItem("securetoken", securetoken||"2e780fee-5aef-44fe-90b6-02e276e532aa")
    console.log(CID)
    async function fetchData() {
      let response = await getCustomerDetails(CID || "", securetoken || "")


      console.log("customerDetails:", response)
      localStorage.setItem("customerDetails", JSON.stringify(response[0]));
      localStorage.setItem("EstimatorVideo", response[0].estimatorVideo);
      var signDone = response[0].customerSigFlag;
      var paymentDone = response[0].paymentFlag
      /* if(signDone ==="1" || paymentDone==="1")
      {
        navigate("/landingBooked")
      } */



      /*       var signDone = "0" //response[0].customerSigFlag
            var paymentDone = "0"// response[0].paymentFlag
      
            if(signDone ==="1" && paymentDone==="1")
      {
      navigate("/move?question=booked")
      }
      
      if(signDone==="1" && paymentDone==="0"){
        navigate("/move?question=deposit")
      
      } */
    }
    fetchData();

    //  getFormPages();
  }, []);

  return (
    <Provider store={store}>
      <ApolloProvider client={client}>
        <Location>
          {({ location, navigate }) => {
            //@ts-ignore
            const { oldLocation } = location.state || {};
            return (
              < >
                <Routes location={oldLocation != null ? oldLocation : location} />
                {/* <Dialog
              style={{zIndex: 9500}}
              isOpen={oldLocation != null}
              onDismiss={() => {
                navigate(oldLocation.pathname);
              }}
            >
              <Routes location={location} />
            </Dialog> */}
              </>
            );
          }}
        </Location>
      </ApolloProvider>
    </Provider>

  );
}

export default App;
